import { render, staticRenderFns } from "./welcome-screen-list-item.vue?vue&type=template&id=f5deb7e2"
import script from "./welcome-screen-list-item.component.js?vue&type=script&lang=js&external"
export * from "./welcome-screen-list-item.component.js?vue&type=script&lang=js&external"
import style0 from "./welcome-screen-list-item.vue?vue&type=style&index=0&id=f5deb7e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VImg,VList,VListItem,VMenu})
